/* eslint react/no-did-mount-set-state: 0, complexity: 0 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {TESTS, getValue} from '../../../utils/abacus';
import {pushEdapEvent} from '../../../utils/edap';
import {wrapInTest} from '../../common/mvt/utils/mvt';

import {CHEVRON_DOWN__16} from '@homeaway/svg-defs';
import {SVGIcon} from '@homeaway/react-svg';

function mapStateToProps(state) {
    return {
        abacus: state.abacus,
        slpText: state.content.slpTextNoSeoFallback
    };
}

const slpTextItem = PropTypes.shape({
    content: PropTypes.string,
    seoDescriptionType: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string
});

const ACTION_LOCATION = 'text-component';
const EVENT_CATEGORY = 'interaction-click';
const EVENT_TYPE = 'generic.event';

export class SEOTextRevisedComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            slpText: this.props.slpText || []
        };
    }

    static propTypes = {
        baseCls: PropTypes.string,
        slpText: PropTypes.arrayOf(slpTextItem)
    };

    static defaultProps = {
        baseCls: 'seo-text'
    };

    componentDidMount() {
        this.toggleContentAtIndex(0, false);
    }

    toggleContent = (index) => {
        return () => {
            this.toggleContentAtIndex(index);
        };
    }

    toggleContentAtIndex(index, fireEDAP = true) {
        const slpText = this.state.slpText;

        if (!slpText[index]) {
            return;
        }

        slpText[index].expanded = !slpText[index].expanded;

        this.setState({slpText});

        if (fireEDAP) {
            pushEdapEvent(EVENT_TYPE, {
                actionlocation: ACTION_LOCATION,
                eventcategory: EVENT_CATEGORY,
                eventaction: slpText[index].expanded ? 'expand' : 'collapse',
                eventrefinements: slpText[index].seoDescriptionType
            });
        }
    }

    render() {
        const {
            abacus,
            baseCls
        } = this.props;

        const {slpText} = this.state;

        const baseClsItem = `${baseCls}-item`;

        const testValue = getValue(abacus, TESTS.SEO_TEXT_REDESIGN);

        const seoText = slpText.length
            ? <div className={'col-md-12'}>
                {slpText.map(({content, expanded, seoDescriptionType, title, type}, index) => {
                    const seoDescriptionTypeLC = seoDescriptionType.toLowerCase();
                    const contentID = `${baseClsItem}__${seoDescriptionTypeLC}`;

                    /* eslint-disable react/no-danger */
                    return (<div
                        className={`${baseClsItem} ${expanded ? `${baseClsItem}__expanded` : ''}`}
                        id={contentID}
                        key={seoDescriptionTypeLC}
                        ref={contentID}
                    >
                        <span
                            className={`${baseClsItem}__title`}
                            role={'button'}
                            onClick={this.toggleContent(index)}>
                            <SVGIcon className={`${baseClsItem}__icon`} markup={CHEVRON_DOWN__16} />
                            <span className={`${baseClsItem}__title__text`}>{title}</span>
                        </span>
                        <div
                            className={`${baseClsItem}__content ${baseCls}-type-${type} seo-description-type-${seoDescriptionTypeLC}`}
                            dangerouslySetInnerHTML={{__html: content}}
                        />
                    </div>);
                    /* eslint-enable react/no-danger */
                })}
            </div>
            : null;

        const component = testValue === 1
            ? (<div className={`container module ${baseCls}`} ref={'container'}>
                <div className={'content'}>
                    <div className={'row'}>
                        {seoText}
                    </div>
                </div>
            </div>)
            : null;

        return wrapInTest(abacus, TESTS.SEO_TEXT_REDESIGN, component);
    }
}

export const SEOTextRevised = connect(mapStateToProps)(SEOTextRevisedComponent);
export default SEOTextRevised;
